const boxShadows = {
};

export { boxShadows };
